/* eslint-disable no-else-return */
import { std } from './std';

/** Returns the intersection if both `a` and `b` are not empty.
 * Else it will return the array that is not empty or null if both empty */
export function getMaybeArraysIntersection<T>(
    a: T[] | null | undefined,
    b: T[] | null | undefined,
): T[] | null {
    if (!!a?.length && !!b?.length) {
        return std.Array.intersection(a, b);
    } else if (!!a?.length) {
        return a;
    } else if (!!b?.length) {
        return b;
    } else return null;
}
